/**
 * Created by Karol Kluska on 27.06.17.
 */

angular
  .module('app')
  .factory('Params', Params);

function Params($stateParams, ParamsValidator) {
  var $this = this;
  $this.$stateParams = $stateParams;
  $this.ParamsValidator = ParamsValidator;
  $this.availableLanguages = null;
  $this.minCheckInTime = null;

  function setMinCheckInTime(time) {
    $this.minCheckInTime = time;
  }

  function setAvailableLanguages(languages) {
    $this.availableLanguages = languages;
  }

  function getUserHash() {
    var userHash = $this.$stateParams.userHash;
    if ($this.ParamsValidator.isValidUserHash(userHash)) {
      return userHash;
    }
    return null;
  }

  function getHotelId() {
    var hotelId = $this.$stateParams.hotelId;
    if ($this.ParamsValidator.isValidHotelId(hotelId)) {
      return parseInt(hotelId, 10);
    }
    return null;
  }

  function getLanguage() {
    var language = $this.$stateParams.language;
    if ($this.ParamsValidator.isValidLanguage(language, $this.availableLanguages)) {
      return language;
    }
    return 'en';
  }

  function getCategoryId() {
    var categoryId = $this.$stateParams.categoryId;
    if ($this.ParamsValidator.isValidCategoryId(categoryId)) {
      return parseInt(categoryId, 10);
    }
    return null;
  }

  function getRoomGroupId() {
    var roomGroupId = $this.$stateParams.roomGroupId;
    if ($this.ParamsValidator.isValidRoomGroupId(roomGroupId)) {
      return parseInt(roomGroupId, 10);
    }
    return null;
  }

  function getRateplanId() {
    var rateplanId = $this.$stateParams.rateplanId;
    if ($this.ParamsValidator.isValidRateplanId(rateplanId)) {
      return parseInt(rateplanId, 10);
    }
    return null;
  }

  function getCheckIn() {
    var checkIn = $this.$stateParams.checkIn;
    if ($this.ParamsValidator.isValidCheckIn(checkIn, $this.minCheckInTime)) {
      return moment(checkIn).format('YYYY-MM-DD');
    } else if ($this.ParamsValidator.isValidCheckIn(checkIn)) {
      return moment(checkIn).add(1, 'day').format('YYYY-MM-DD');
    }
    var now = moment().format('YYYY-MM-DD');
    if ($this.ParamsValidator.isValidCheckIn(now, $this.minCheckInTime)) {
      return moment(now).format('YYYY-MM-DD');
    }
    return moment(now).add(1, 'day').format('YYYY-MM-DD');
  }

  function getCheckOut() {
    var checkIn = getCheckIn();
    var checkOut = $this.$stateParams.checkOut;
    if ($this.ParamsValidator.isValidCheckOut(checkIn, checkOut)) {
      return moment(checkOut).format('YYYY-MM-DD');
    }
    return moment(checkIn).add(1, 'day').format('YYYY-MM-DD');
  }

  function getOccupancy() {
    var occupancy = $this.$stateParams.occupancy;
    if ($this.ParamsValidator.isValidOccupancy(occupancy)) {
      occupancy = angular.fromJson(decodeURIComponent(occupancy));
      angular.forEach(occupancy, function (room) {
        if ($this.ParamsValidator.isValidOccupancyCat1(room.cat1) === false) {
          room.cat1 = 0;
        }
        if ($this.ParamsValidator.isValidOccupancyCat1(room.cat2) === false) {
          room.cat2 = 0;
        }
        if ($this.ParamsValidator.isValidOccupancyCat1(room.cat3) === false) {
          room.cat3 = 0;
        }
      });
      return occupancy;
    }
    return [{count: 2, cat1: 0, cat2: 0, cat3: 0}];
  }

  function getCart() {
    var cart = $this.$stateParams.cart;
    if ($this.ParamsValidator.isValidCart(cart)) {
      return angular.fromJson(decodeURIComponent(cart));
    }
    return null;
  }

  function getDiscountCode() {
    var code = $this.$stateParams.discountCode;
    if ($this.ParamsValidator.isValidDiscountCode(code)) {
      return code;
    }
    return null;
  }

  function getPaymentToken() {
    var token = $this.$stateParams.token;
    if ($this.ParamsValidator.isValidPaymentToken(token)) {
      return token;
    }
    return null;
  }

  return {
    setMinCheckInTime: setMinCheckInTime,
    setAvailableLanguages: setAvailableLanguages,
    getUserHash: getUserHash,
    getHotelId: getHotelId,
    getLanguage: getLanguage,
    getCategoryId: getCategoryId,
    getRoomGroupId: getRoomGroupId,
    getRateplanId: getRateplanId,
    getCheckIn: getCheckIn,
    getCheckOut: getCheckOut,
    getOccupancy: getOccupancy,
    getCart: getCart,
    getDiscountCode: getDiscountCode,
    getPaymentToken: getPaymentToken
  };
}
